var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropdownArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    viewBox: "0 0 11 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.62526 0.0834961C10.2395 0.0834961 10.5603 0.82986 10.1897 1.31204L10.1349 1.37563L5.80944 5.9174C5.6853 6.04773 5.52014 6.12602 5.34494 6.13759C5.16973 6.14916 4.99653 6.0932 4.85782 5.98023L4.79006 5.9174L0.464548 1.37563L0.404712 1.30447L0.365782 1.24619L0.326853 1.17352L0.314597 1.14627L0.295132 1.09555L0.272063 1.0138L0.264854 0.973682L0.257645 0.928265L0.254761 0.885118V0.795797L0.258365 0.751893L0.264854 0.706475L0.272063 0.667113L0.295132 0.585362L0.314597 0.534645L0.365062 0.434726L0.411921 0.366599L0.464548 0.305286L0.532314 0.242458L0.587825 0.201582L0.657033 0.160706L0.682986 0.147838L0.731288 0.1274L0.809147 0.103177L0.847356 0.0956073L0.890611 0.0880375L0.931703 0.0850099L9.62526 0.0834961Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownArrow);
export default __webpack_public_path__ + "static/media/dropdown-arrow.ef4773658a2fe4c9f8afd2601b902e49.svg";
export { ForwardRef as ReactComponent };